import { Route, Routes } from "react-router-dom";
import QuizAttemptRoute from "./QuizAttempt/quiz-attempt";
import QuizAttemptReviewRoute from "./QuizAttemptReview/quiz-attempt-review";

const QuizAttemptsRoute = () => {
  return (
    <div className="px-4 py-6 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl">
        <Routes>
          <Route path=":id">
            <Route path="review" element={<QuizAttemptReviewRoute />} />
            <Route index element={<QuizAttemptRoute />} />
          </Route>
        </Routes>
      </div>
    </div>
  );
};

export default QuizAttemptsRoute;
